import React from 'react';
import { styled } from '@nykaa/ui-components';
const Container = styled.span `
  margin: 8px;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
const TagName = styled.span `
    ${({ theme }) => theme.typography.type120};
    border-radius: ${({ theme }) => theme.borders.radius10};
    padding:  ${({ theme }) => theme.spacing.spacing20};
    color: ${({ theme }) => theme.colors.primary40};
    background-color: ${({ theme }) => theme.colors.primary10};
    border: none;
    letter-spacing: 0.5px;
    & {
      background-color: ${({ badgeColor }) => badgeColor};
      color:  ${({ textColor }) => textColor};
    }
`;
const SaleTags = ({ plpPriceReveal, }) => {
    const { text: tagName = '', textColor, badgeColor } = plpPriceReveal;
    return (React.createElement(Container, null,
        React.createElement(TagName, { textColor: textColor, badgeColor: badgeColor }, tagName)));
};
export default SaleTags;
